import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectParametersService} from "@catmodels/project-parameters/services/project-parameters.service";
import {Subscription} from "rxjs";
import {isNullOrUndefined} from "util";
import {ProjectMediaSources} from "@catmodels/project-media-sources/types";
import {extractDataFromModel} from "@catcore/utils";
import {ProjectService} from "@catcore/services";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'catapp-parameter-search',
  templateUrl: './parameter-search.component.html',
  styleUrls: ['./parameter-search.component.scss']
})
export class ParameterSearch implements OnInit, OnDestroy {

  private projectSubscription: Subscription;
  private project = null;

  private searchParamsSubscription: Subscription;
  private fileListSubscription: Subscription;

  fileList: any[] = [];
  form: FormGroup;

  private parameterList;

  constructor(private projectService: ProjectService,
              private projectParametersService: ProjectParametersService) {
    this.form = new FormGroup({
      search: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.project = project;
          this.fileListSubscription = this.projectService.getUploadFiles(this.project)
            .subscribe((files) => {
              extractDataFromModel(files, 'item', '_embedded').forEach((file) => {
                this.fileList.push({label: file.filename, value: file._links.self.href});
              });
              this.fileList.push({label: 'empty', value: null});
            });
        }
      });

    this.projectParametersService.setActive();
  }

  ngOnDestroy() {
    if (this.projectSubscription) {
      this.projectSubscription.unsubscribe();
    }
    if (this.searchParamsSubscription) {
      this.searchParamsSubscription.unsubscribe();
    }
    if (this.fileListSubscription) {
      this.fileListSubscription.unsubscribe();
    }
    this.projectParametersService.setInActive();
  }

  onSubmitSearch($event) {
    if (!this.activeProject()) {
      return;
    }

    if (this.searchParamsSubscription) {
      this.searchParamsSubscription.unsubscribe();
    }
    this.searchParamsSubscription = this.projectService.searchParameters(this.project,
      this.form.value.search).subscribe((paramList: any) => {
        if (paramList && paramList._embedded && paramList._embedded.item) {
          this.parameterList = paramList._embedded.item;
        } else {
          this.parameterList = [];
        }
    });

  }

  private activeProject() {
    return !isNullOrUndefined(this.project) && !isNullOrUndefined(this.project.id)
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-parameters/components/parameter-search/parameter-search.component.ts